import axios, { AxiosPromise } from 'axios';
import { IFreshServiceTicketFormValues } from '../../../@types/model/freshService/freshServiceTicketFormValues';

export default class FreshServiceHttpService {
    public static upsert = (ticketValues : IFreshServiceTicketFormValues) : AxiosPromise => {
        return axios.post(`${API_URL}/v1/FreshService/CreateTicket`, ticketValues);
    };
}
